import * as React from 'react';
import classNames from 'classnames';
import {
  Focusable,
  OverlayArrow,
  Tooltip as ReactAriaTooltip,
  TooltipProps as ReactAriaTooltipProps,
  TooltipTrigger,
} from 'react-aria-components';

import styles from './Tooltip.module.css';

export interface TooltipProps extends ReactAriaTooltipProps {
  children: React.ReactNode;
  text: React.ReactNode;
  className?: string;
}

export default function Tooltip({children, text, className, ...props}: TooltipProps) {
  return (
    <TooltipTrigger delay={0}>
      <Focusable>
        <div className={styles.tooltipTarget}>{children}</div>
      </Focusable>
      <ReactAriaTooltip className={classNames(className, styles.tooltip)} {...props}>
        <OverlayArrow className={styles.arrow}>
          <svg width={12} height={12} viewBox="0 0 12 12">
            <path d="M0 0 L6 6 L12 0" />
          </svg>
        </OverlayArrow>
        {text}
      </ReactAriaTooltip>
    </TooltipTrigger>
  );
}
